import { Link } from 'react-router-dom';
import { navItems } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="relative bg-secondary-900 text-background-50 mt-20 mx-4 md:mx-6 rounded-2xl rounded-b-none overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <span className="text-3xl font-heading text-background-50 whitespace-nowrap">
                吃瓜51
              </span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed max-w-xs">
              聚焦51个热门话题，每日更新网红翻车现场与独家爆料。吃瓜51网，满足你对娱乐圈和社会热点的所有好奇心。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-50 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-50 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-links-line text-background-50 text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 whitespace-nowrap">热门频道</h4>
            <ul className="flex flex-col gap-3">
              {navItems.filter(i => i.label !== '首页').map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 whitespace-nowrap">关于我们</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 whitespace-nowrap">订阅吃瓜日报</h4>
            <p className="text-sm text-secondary-300 mb-4 leading-relaxed">
              不错过任何大瓜！每日精选热点推送至您的邮箱。
            </p>
            <NewsletterForm />
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700/50">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; 2026 吃瓜51网 Chigua51.com 版权所有
          </p>
          <p className="text-xs text-secondary-500">
            每日更新 · 吃瓜第一线
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pointer-events-none select-none">
        <span className="block text-[120px] md:text-[160px] font-heading text-secondary-800/20 leading-none text-center whitespace-nowrap">
          吃瓜51
        </span>
      </div>
    </footer>
  );
}

function NewsletterForm() {
  return (
    <form
      className="flex items-center gap-0"
      onSubmit={(e) => e.preventDefault()}
     
    >
      <input
        type="email"
        name="email"
        placeholder="输入邮箱地址"
        className="flex-1 h-10 px-4 text-sm bg-secondary-800 border border-secondary-600 rounded-l-full text-background-50 placeholder:text-secondary-400 outline-none focus:border-primary-500 transition-colors"
      />
      <button
        type="submit"
        className="h-10 px-5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-r-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
      >
        订阅
      </button>
    </form>
  );
}